var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.985,
    height: 20,
    viewBox: "0 0 19.985 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-export",
    d: "M15.55,17.417a.824.824,0,0,0-1.175.075,2.493,2.493,0,0,1-1.875.85H4.167a2.507,2.507,0,0,1-2.5-2.5V4.167a2.507,2.507,0,0,1,2.5-2.5H7.925a3.346,3.346,0,0,1,.408.017v4.15a2.507,2.507,0,0,0,2.5,2.5h4.842a.821.821,0,0,0,.658-.325.851.851,0,0,0,.15-.717,5.814,5.814,0,0,0-1.525-2.683l-2.9-2.9A5.8,5.8,0,0,0,7.933,0H4.167A4.168,4.168,0,0,0,0,4.167V15.833A4.168,4.168,0,0,0,4.167,20H12.5a4.191,4.191,0,0,0,3.125-1.408A.824.824,0,0,0,15.55,17.417ZM10,2.217a4.235,4.235,0,0,1,.875.675l2.9,2.9a4.263,4.263,0,0,1,.667.875H10.825a.836.836,0,0,1-.833-.833V2.217Zm9.275,12.858-1.342,1.342a.818.818,0,0,1-.592.242.854.854,0,0,1-.592-.242.83.83,0,0,1,0-1.175l1.075-1.075H11.658a.833.833,0,0,1,0-1.667h6.167L16.75,11.425a.831.831,0,0,1,1.175-1.175l1.342,1.342a2.48,2.48,0,0,1,0,3.492Z",
    fill: "#9c9baa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileExport);
export default __webpack_public_path__ + "static/media/file-export.2dd3618768e488e0a2e3c8085798fde2.svg";
export { ForwardRef as ReactComponent };